import {Component, ElementRef, EventEmitter, HostListener, OnInit, Output, ViewChild} from '@angular/core';
import {
  ColDef,
  Column, ColumnApi,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererComp,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
  SelectionChangedEvent
} from "ag-grid-community";
import {debounceTime, distinctUntilChanged, map, Observable} from "rxjs";

import {NgbTypeaheadSelectItemEvent} from "@ng-bootstrap/ng-bootstrap";
import {Router} from "@angular/router";

import {Location} from "@angular/common";

import {NgSelectComponent} from "@ng-select/ng-select";
import {FormControl, NgModel, Validators} from "@angular/forms";
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { environment } from 'src/environments/environment';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { MenusService } from 'src/app/_services/menu.service';
import { AlertService } from 'src/app/_services/alert.service';
import { SideNavService } from '../../layout/sidebar/side-name.service';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { SidebarComponent } from '../../layout/sidebar/sidebar.component';
import { StorageService } from 'src/app/_services/storage.service';
import { MerchantFilter } from '../resellers/reseller-master/reseller.service';



const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'


const {API_URL, defaultPageSizeArr, defaultPageSize} = environment;

// const API_URL = 'http://localhost:8000'
export interface IMerchantData {
  "bussinessCategories": string,
  "bussinessSubCategories": string,
  "riskLevel": string,
  "riskLevelCode": string,
  "bussinessCategoriesID": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}

export class DetailCellRenderer implements ICellRendererComp {
  eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = '<h1 style="padding: 20px;">My Custom Detail</h1>';
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}


@Component({
  selector: 'app-leadmasterlist',
  templateUrl: './leadmasterlist.component.html',
  styleUrls: ['./leadmasterlist.component.scss']
})
export class LeadmasterlistComponent implements OnInit {

 

 
  @Output() merchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() merchantConfigEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  
  // @Output() isEdit: EventEmitter<any> = new EventEmitter<any>();
  public quickFilterShow: boolean = false;
  public pageSize: number = defaultPageSize;
  public pageSizeArr: any = defaultPageSizeArr;
  public searchMerName:string;
  public searchMID: any ;
  public resellerPartnerId:any;
  public Status:string;
  public searchFromDate: string;
  public searchToDate: string;
  public selectedMerchant: string;
  public valevent1:any=null
 public valevent2:any=null
 public valevent3:any=null

  public page: number = 1
  
  merchantStatus: any;
  public detailCellRenderer = new DetailCellRenderer;
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 300,
    resizable: true,
    sortable: true,
    // suppressSizeToFit: true,
    // suppressAutoSize: true,
    filter: false,
    autoHeight: true
  };
  dynamicDate:any =this.getToday();
  public rowData!: IMerchantData[];
  tablecolumn: any;
  currentPage: number = 1;
  globalSearch: string = '';
  collectionSize: number = 0;
  collectiondata: number=0
  modalConfigAdd: ModalConfig;
  modalConfigEdit: ModalConfig;
  modalConfigMerchant: ModalConfig;
  Merchantdata: any;
  modalConfigBlocked: ModalConfig;
  public menuItems: any;
  public permissions: any = '';
  currentDate:any=new Date();
  tableInfo: any;
  @ViewChild('modalbloked') private modalblockedComponent: ModalComponent;
  @ViewChild('categorysearch') private categorysearch: NgSelectComponent;
  @ViewChild('subCategorySearch') private subCategorySearch: NgSelectComponent;
  @ViewChild('risksearch') private risksearch: NgSelectComponent; 
  ;

  public columnDefs: ColDef[] = [
    {field: 'mobileNumber', tooltipField: 'mobileNumber', headerName: 'Mobile Number',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    {field: 'email',tooltipField: 'email', headerName: 'Email Id',resizable: true},
    {field: 'website' ,tooltipField: 'website', headerName: 'Website',resizable: true},
    {field: 'personPanName',tooltipField: 'personPanName', headerName: 'Person Pan Name',resizable: true},
    {field: 'companyPanName', tooltipField:'companyPanName',headerName: 'Company Pan Name',hide:true,resizable: true},  
    {field: 'legalName', tooltipField:'legalName',headerName: 'Legal Name' ,hide:true,resizable: true}, 

    {field: 'tradeName', tooltipField: 'tradeName', headerName: 'Trade Name',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    {field: 'aboutBusiness',tooltipField: 'aboutBusiness', headerName: 'About Business',resizable: true},
    {field: 'address' ,tooltipField: 'address', headerName: 'Address',resizable: true},
    {field: 'gstNumber',tooltipField: 'gstNumber', headerName: 'GST Number',resizable: true},
    {field: 'dateOfIncorporation', tooltipField:'dateOfIncorporation',headerName: 'Date Of Incorporation',hide:true,resizable: true},  
    {field: 'aadharNumber', tooltipField:'aadharNumber',headerName: 'Aadhar Number' ,hide:true,resizable: true}, 

    {field: 'turnOver', tooltipField: 'turnOver', headerName: 'Turn Over',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    {field: 'platForm',tooltipField: 'platForm', headerName: 'Platform',resizable: true},
     {field: 'callBackTime',tooltipField: 'callBackTime', headerName: 'Call Back Time',resizable: true},
     {field: 'remark' ,tooltipField: 'remark', headerName: 'Remark',resizable: true},
    // {field: 'personPanName',tooltipField: 'personPanName', headerName: 'Person Pan Name',resizable: true},
    // {field: 'companyPanName', tooltipField:'companyPanName',headerName: 'Company Pan Name',hide:true,resizable: true},  
    // {field: 'legalName', tooltipField:'legalName',headerName: 'Legal Name' ,hide:true,resizable: true}, 

    // {field: 'mobileNumber', tooltipField: 'mobileNumber', headerName: 'Mobile Number',  cellRenderer: 'agGroupCellRenderer',resizable: true,},
    // {field: 'email',tooltipField: 'email', headerName: 'Email Id',resizable: true},
    // {field: 'website' ,tooltipField: 'website', headerName: 'Website',resizable: true},
    // {field: 'personPanName',tooltipField: 'personPanName', headerName: 'Person Pan Name',resizable: true},
    // {field: 'companyPanName', tooltipField:'companyPanName',headerName: 'Company Pan Name',hide:true,resizable: true},  
    // {field: 'legalName', tooltipField:'legalName',headerName: 'Legal Name' ,hide:true,resizable: true}, 
   
  ];
  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  private gridApi!: GridApi;
  private filterObj: any = {};
 // @ViewChild('modalEdit') private modalEditComponent: ModalComponent
  @ViewChild('modalAdd') private modalAddComponent: ModalComponent
  @ViewChild('modalMerchant') private modalMerchantComponent: ModalComponent
//  @ViewChild('modalMerchantBank') private modalMerchantBankComponent: ModalComponent
  private innerWidth: number;
  private _event: any;
  resellerListOptions: any;
  merchantStatusdata: any;
  Resultdata: any;
  private gridColumnApi!: ColumnApi;
  totalRecord: any;

  constructor(private menuService: MenusService, private location: Location, private alertService: AlertService, private sideNavService: SideNavService, private merchantService: MerchantService, private router: Router, private sidebarComponent: SidebarComponent, private storageService: StorageService) {
   // this.merchantService.getBusinessType().subscribe((data) => this.merchantStatus = data)
    console.log("============>", this.tableSelectedColumn);
    //this.getRiskData();
  }

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map((term: string) => term.length < 2 ? []
        : this.rowData.filter(v => (v.bussinessCategories.toLowerCase().indexOf(term.toLowerCase()) > -1)).map(v => v.bussinessCategories).slice(0, 10))
    );
  maxSize: number;
  ellipses: boolean= true;

  async ngOnInit(): Promise<void> {
    
    //this.getRiskData();
    this.getBusinessCatigory();
    this.getLeadReport();
    this.innerWidth = window.innerWidth;
    this.setPageSize();
    const path = this.location.prepareExternalUrl(this.location.path());
    this.permissions = this.menuService.getPermissions(path);
    // if (this.permissions == null || this.permissions == '' || !this.permissions) {
    //   this.alertService.errorAlert({
    //     title: "No Access",
    //     backdrop: true,
    //     toast: true,
    //     timer: 1500
    //   })
    //   await this.router.navigateByUrl('/');
    // }

    this.modalConfigBlocked = {
      modalTitle: "Merchant Status",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }
    this.modalConfigAdd = {
      modalTitle: "Add Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

    this.modalConfigEdit = {
      modalTitle: "Edit Merchant",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
    this.modalConfigMerchant = {
      modalTitle: "Merchant RMS Configuration",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }

  //  this.merchantService.getResellerList().subscribe((data) => this.resellerListOptions = data)
    //this.merchantStatusDropdown()
    this.getLeadReport();
    
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    console.log(this.innerWidth, "------->");
    this._event = event;
    this.innerWidth = window.innerWidth;
    this.setPageSize();
  }

  onSortChange(event : any){
    const listOfSortModel =  this?.gridColumnApi?.getColumnState().filter(s => s.sort !== null)
    console.log("==Sort===>", listOfSortModel);
  }

  changeDate(){
    this.currentDate=this.searchFromDate
  }


  changeEndDate()
  {
    this.currentDate=this.searchToDate
  }


  setPageSize(){
 
    if (this.innerWidth <= 1600 && this.innerWidth >= 1200) {
      this.maxSize = 5;
    } else if (this.innerWidth <= 1199 && this.innerWidth >= 768) {
      this.maxSize = 3;
      this.ellipses = false;
    }else if (this.innerWidth < 768) {
      this.maxSize = 2;
      this.ellipses = false;
      // this.columnDefs = this.columnDefs.map((col)=>{
      //   if(col.field == 'actions'){
      //     col.pinned = null;
      //   }
      //   return col;
      // });
    }
    // this.gridApi.setColumnDefs(this.columnDefs)
  }

  updateSelectedColumn(event : any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  quickFilterShowAction($event: Event) {
    this.quickFilterShow = !this.quickFilterShow
    if (!this.quickFilterShow) {
      // this.searchToDate = '';
      // this.searchFromDate = '';
      // this.searchMID = '';
      // this.searchMerName = '';
      // this.resellerPartnerId= '',
      // this.Status= ''
      this.categorysearch.handleClearClick();
      this.subCategorySearch.handleClearClick();
      this.risksearch.handleClearClick();
     // this.filStatus.handleClearClick();
      this.searchFromDate = '';
      this.searchToDate = '';
      this.refreshGrid();
    }
  }

  onSearchBtnClick(event: Event) {
    // Prevent default form submission behavior
    event.preventDefault();

    // Perform the search based on the search criteria
    if (this.searchMerName || this.searchMID) {
      // Prepare the data object to send in the request body
      const requestData = {
        mobile: this.searchMerName,
        email: this.searchMID
      };
      this.merchantService.getLeadReportByMobileEmail(requestData,this.page,this.pageSize).subscribe((data)=>{
        debugger
       
           this.rowData = data.content  || data || [],
           this.collectiondata = data?.totalElements||0
           this.collectionSize=this.collectiondata  
          if(this.rowData.length <=0){
            this.alertService.errorAlertWithMessage("No records present");
            return }
     
       })
     // this.applyFilter('mobileNumber', this.searchMerName);
    
    } else {
      // Handle case when neither search criteria is provided
      this.getLeadReport();
      // Optionally, reset the filter to display all data in the table/grid
      this.resetFilter();
    }
  }

  applyFilter(column: string, value: string) {
    // Apply filter to the table/grid data based on the provided column and value
    // Example:
     this.gridApi.setFilterModel({ [column]: { type: 'contains', filter: value } });
  }

  resetFilter() {
    // Reset the filter to display all data in the table/grid
    // Example:
    // this.gridApi.setFilterModel(null);
  }

 
  


  closeModalAdd($event: any) {
    if (!$event.showModal) {
      this.modalAddComponent.close();
      this.refreshGrid();
    }

  }

  refreshGrid() {
    this.gridApi.applyTransaction({remove: this.rowData});

    return this.merchantService.getLeadReport(this.pageSize, (this.currentPage - 1))
      .subscribe((data) => (this.rowData = data.content || data.content || data, 
        this.collectiondata = data.totalCount || data.totalElements || data.totalElements || data.length,  this.collectionSize=this.collectiondata-10
        ));
  }
  // refreshGrid() {
  //   this.gridApi.applyTransaction({remove: this.rowData});
  //   //this.getRiskData();   
  // }


  onGridReady(params: GridReadyEvent<IMerchantData>) {
    
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.getFilterInstance('age', (filterParam) => {
    })
    this.gridApi.showLoadingOverlay();
    this.gridApi.setQuickFilter(this.globalSearch);
    const allColumnIds: (string | Column)[] = [];
    params?.columnApi?.getColumns()?.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    params?.columnApi?.autoSizeColumns(allColumnIds, false);
   
   // this.getRiskData();
   this.getLeadReport();
  }

  onBtnC(e: Event) {
    e.preventDefault();
    // @ts-ignore
    return this.apiHttpService
      .get(
        `${API_URL}/get-merchant`
      )
      // @ts-ignore
      .subscribe((data) => (this.gridApi.applyTransaction({add: data})));
  }

  onExportCSV() {
    // @ts-ignore
    const random3 = Math.floor(Math.random() * 10000000000 + 1);
    const today = new Date();
    const referenceId = today.getFullYear().toString() + "-" + ("0" + (today.getMonth() + 1)).slice(-2) + "-" + ("0" + today.getDate()).slice(-2) + "_" + (("0" + today.getHours())).slice(-2) + "-" + (("0" + today.getMinutes())).slice(-2) + "-" + (("0" + today.getSeconds())).slice(-2);
    const fileName = 'Lead Report' + "_" + referenceId;
    const filter: MerchantFilter = {}
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }

     
    if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';  

    filter.columns = {};
    this.tableSelectedColumn.forEach((col) => {
      if (col?.field) filter['columns'][col?.field] = col?.headerName
    })
   
    // return this.merchantService.getRiskData(this.totalRecord, 0, filter)
    return this.merchantService.getLeadReport(this.page,this.pageSize)
      .subscribe((data:any) => {
        
        const expData: any[] = [];
        (data?.content || data || []).forEach((curr: any) => {
          const tempRec: any = {}          
          this.tableSelectedColumn.forEach((col) => {         
            if(!(col?.field=="actions"))
            {
            if (col?.field) tempRec[col?.field] = curr[col?.field]
          }})
          expData.push(tempRec);
        })

        // this.JSONToCSVConvertor(data?.data || data?.merchants || data || [],fileName, "Report");
        this.exportAsExcelFile(expData, fileName);
      })




  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
   
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
   
    const tempRec: any = []
    var index=0;
    this.tableSelectedColumn.forEach((col) => {
      if(!( col?.field=="actions"))
      {
       tempRec[index] = col
       index++;
    }})
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      // @ts-ignore
      header: [...tempRec.map((col:any) => col.headerName)]
    });
    // const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    const wb = XLSX.utils.book_new();
    XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col:any) => col.headerName)]]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  searchQuickFilter($event?: NgbTypeaheadSelectItemEvent) {
    this.gridApi.setQuickFilter($event?.item);
  }

  onGlobalSearchChange($event: any) {
    if ($event == '' || $event == null) {
      this.gridApi.setQuickFilter($event);
    }
  }

 

  async MerchantNew() {
    return await this.modalMerchantComponent.open();
  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.page=param;
    
    this.gridApi.applyTransaction({remove: this.rowData})
     this.gridApi.showLoadingOverlay();
   
    this.getLeadReport();
   
  }

  onRowClicked(param: RowClickedEvent | any) {
    console.log("Row Clicked", param);
  }
  getToday(): string {
    return new Date().toISOString().split('T')[0]
  }


  async onRowDoubleClicked(param: RowClickedEvent | any) {  

  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onFilterModified(param: FilterModifiedEvent | any) {
    // console.log("onFilterModified----->",param);
    const temp = param?.filterInstance;
    this.filterObj[param?.column?.colId] = temp;
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }

  onPageSizeChanges($event: Event) {
  
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({remove: this.rowData})
    this.gridApi.showLoadingOverlay();
    const filter: MerchantFilter = {}
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
    if(this.Status !="")
    {
      filter.name = this.searchMerName?this.searchMerName:''+this.Status?this.Status:'';
    }
    else
    {
    if (this.searchMerName||'') filter.name = this.searchMerName||'';
    }
       if (this.Status != "") {
       } else {
         if (this.searchMerName || '') filter.name = this.searchMerName || '';
       }
       if (this.searchMerName) filter.name = this.searchMerName ?  this.searchMerName : "";
       filter.name = this.searchMerName&&this.Status ? (this.searchMerName+ '|'+this.Status) : (this.Status ?'|'+this.Status :(this.searchMerName?this.searchMerName+'|':'|')) ;
       filter.name = filter.name + '|'; //added | for userType


      
    if (this.searchMID||'') filter.mid = this.searchMID||'';
    if (this.resellerPartnerId||"") filter.rid= this.resellerPartnerId||'';
    if (this.Status) filter.Status=this.Status||'';
    if (this.searchFromDate) filter.startDate = this.searchFromDate;
    if (this.searchToDate) filter.endDate = this.searchToDate;
// this.getRiskData();    
this.getLeadReport();
  }

  


  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalblockedComponent.close();
      this.refreshGrid();
    }
  }

 

  OnlyCharacterAllowed(event: { which: any; keyCode: any; }): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode >= 65 && charCode <= 90) ||(charCode >= 97 && charCode <= 122) || (charCode == 32 )) {
      // console.log('charCode restricted is' + charCode)
      return true;
    }
    return false;
  }

  allowAlfanumeric(event: Event): void {
    this.searchMerName = this.searchMerName.replace(/[^a-z 0-9]/gi,'')||'';
    this.searchMID = this.searchMID.replace(/[^a-z 0-9]/gi,'')||'';
  }
  fun(id:any){
    document?.getElementById(id)?.classList.add("hey")
  }
  funover(id:any){
    document?.getElementById(id)?.classList.remove("hey")
  }


categoryTypeOptions:any;
getBusinessCatigory(){

  this.merchantService.getCategoryType().subscribe((data)=>{
   this.categoryTypeOptions=data;
  
  
    console.log("response=="+JSON.stringify(data))
    console.log("data=="+data)
  })
}


riskcode:any= [
  // { code: 0, value: 0 },
  { code: 1, value: 1 },
  { code: 2, value: 2 },
  { code: 3, value: 3 },
  { code: 4, value: 4 },
  ];

subCategoryTypeOptions:any;
getBusinessSubCatigory(){    
  this.merchantService.getSubCategoryType(this.valevent1).subscribe((data)=>{
  this.subCategoryTypeOptions=data;
    console.log("subCategoryTypeOptions=="+JSON.stringify(this.subCategoryTypeOptions))
    console.log("subCategoryTypeOptions=="+this.subCategoryTypeOptions)
  })
//}
}

isDropdownOpen = false; // Variable to track the dropdown state

 // HostListener to detect clicks outside of the ng-select element
  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: HTMLElement) {
   
    const ngSelectElement = document.querySelector('ng-select');

    // Check if the clicked target is outside the ng-select element and the dropdown is open
    if (!ngSelectElement?.contains(target) && this.isDropdownOpen) {
      this.isDropdownOpen = false;
    }
  }

 
  getLeadReport(){
  
    this.merchantService.getLeadReport(this.page,this.pageSize).subscribe((data)=>{
      debugger
        console.log("LeadReport======="+JSON.stringify(data.content))
       this.rowData = data.content  || data || [],
        this.collectiondata = data?.totalElements||0
        this.collectionSize=this.collectiondata  
       if(this.rowData.length <=0){
         this.alertService.errorAlertWithMessage("No records present");
         return }
   
     })
  }








}
